import axios from "axios";
import { siteSettings } from "../static";

/**
 * @param {File} file
 * @param {(progressEvent: import("axios").AxiosProgressEvent) => void} [onUploadProgress]
 * @returns {Promise<string>}
 */
export async function uploadImageToCloudinary(file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", siteSettings.uploadPreset);

  const response = await axios.post(
    `https://api.cloudinary.com/v1_1/${siteSettings.cloudName}/image/upload`,
    formData,
    onUploadProgress ? { onUploadProgress } : {}
  );

  return response.data.secure_url;
}
